import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, ChevronDown } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const navTo = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
    setServicesOpen(false);
  };

  const linkClass = (path) =>
    `transition-colors duration-200 font-medium ${isActive(path) ? 'text-cyan-400' : 'text-slate-300 hover:text-cyan-400'}`;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-900/95 backdrop-blur-lg shadow-lg shadow-cyan-500/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navTo('/')}>
            <img
              src="https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/o2t5vwwy_logo.jpeg"
              alt="FrostByte IT Logo"
              className="h-12 w-12 object-contain"
            />
            <span className="text-2xl font-bold text-white">
              FrostByte<span className="text-cyan-400">IT</span>
            </span>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => navTo('/')} className={linkClass('/')}>Home</button>

            {/* Services Dropdown */}
            <div className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)}>
              <button className="text-slate-300 hover:text-cyan-400 transition-colors duration-200 font-medium flex items-center gap-1">
                Services <ChevronDown className={`w-4 h-4 transition-transform ${servicesOpen ? 'rotate-180' : ''}`} />
              </button>
              {servicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-slate-900 border border-slate-800 rounded-xl shadow-2xl overflow-hidden">
                  <button
                    onClick={() => navTo('/services/signage')}
                    className="w-full text-left px-5 py-3 text-slate-300 hover:text-cyan-400 hover:bg-slate-800/50 transition-all text-sm"
                  >
                    Digital Signage
                  </button>
                  <button
                    onClick={() => navTo('/services/websites')}
                    className="w-full text-left px-5 py-3 text-slate-300 hover:text-cyan-400 hover:bg-slate-800/50 transition-all text-sm"
                  >
                    Custom Websites
                  </button>
                  <button
                    onClick={() => navTo('/services/it')}
                    className="w-full text-left px-5 py-3 text-slate-300 hover:text-cyan-400 hover:bg-slate-800/50 transition-all text-sm border-t border-slate-800"
                  >
                    IT Services
                  </button>
                </div>
              )}
            </div>

            <button onClick={() => navTo('/contact')} className={linkClass('/contact')}>Contact</button>
            <button onClick={() => navTo('/support')} className={linkClass('/support')}>Support</button>
            <Button
              onClick={() => navTo('/contact')}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-6 transition-all duration-200 shadow-lg shadow-cyan-500/20 hover:shadow-cyan-500/40"
            >
              Get Started
            </Button>
          </nav>

          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-slate-900 border-t border-slate-800 py-4">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => navTo('/')} className="text-slate-300 hover:text-cyan-400 font-medium text-left px-4">Home</button>
              <button onClick={() => navTo('/services/signage')} className="text-slate-300 hover:text-cyan-400 font-medium text-left px-4">Digital Signage</button>
              <button onClick={() => navTo('/services/websites')} className="text-slate-300 hover:text-cyan-400 font-medium text-left px-4">Custom Websites</button>
              <button onClick={() => navTo('/services/it')} className="text-slate-300 hover:text-cyan-400 font-medium text-left px-4">IT Services</button>
              <button onClick={() => navTo('/contact')} className="text-slate-300 hover:text-cyan-400 font-medium text-left px-4">Contact</button>
              <button onClick={() => navTo('/support')} className="text-slate-300 hover:text-cyan-400 font-medium text-left px-4">Support</button>
              <div className="px-4">
                <Button onClick={() => navTo('/contact')} className="bg-cyan-500 hover:bg-cyan-600 text-white w-full">Get Started</Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
